import { Indicator, Item, Root } from '@radix-ui/react-radio-group';
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';

import { cn } from '@/shared/utils/cn/cn.util';

export type RadioGroupProps = ComponentPropsWithoutRef<typeof Root>;
export type RadioGroupItemProps = ComponentPropsWithoutRef<typeof Item>;

export const RadioGroup = forwardRef<ElementRef<typeof Root>, RadioGroupProps>(function RadioGroup(
  { className, ...props },
  ref,
) {
  return <Root ref={ref} className={cn('grid gap-sm', className)} {...props} />;
});

export const RadioGroupItem = forwardRef<ElementRef<typeof Item>, RadioGroupItemProps>(
  function RadioGroupItem({ className, ...props }, ref) {
    return (
      <Item
        ref={ref}
        className={cn(
          'aspect-square h-4 w-4 rounded-full border border-input bg-card text-primary transition-colors duration-fast ease-standard',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'data-[state=checked]:border-primary',
          className,
        )}
        {...props}
      >
        <Indicator className="flex h-full w-full items-center justify-center">
          {/* A filled dot rather than an icon: it stays legible at 16px, where a
              stroked glyph turns to mud. */}
          <span aria-hidden className="block h-2 w-2 rounded-full bg-primary" />
        </Indicator>
      </Item>
    );
  },
);
